import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/LoginPage';
import ErrorPage from './pages/ErrorPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import ExtensionsPage from './pages/ExtensionsPage';
import ReportsPage from './pages/ReportsPage';
import CategoriesPage from './pages/CategoriesPage';
import WaitlistPage from './pages/WaitlistPage';
import PromocodesPage from './pages/PromocodesPage';
import NotificationsPage from './pages/NotificationsPage';
import ArticlesPage from './pages/ArticlesPage';
import HomeLayoutPage from './pages/HomeLayoutPage';
import BoostedCreatorsPage from './pages/BoostedCreatorsPage';
import BoostPage from './pages/BoostPage';
import PayoutRequestsPage from './pages/PayoutRequestsPage';
import VersionControlPage from './pages/VersionControlPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import LegacyOverviewPage from './pages/OverviewPage';
import PeriodDashboardPage from './pages/PeriodDashboardPage';
import ModelsPage from './pages/ModelsPage';
import GenerationUsagePage from './pages/GenerationUsagePage';
import CreditUsagePage from './pages/CreditUsagePage';
import GenerationFailedLogsPage from './pages/GenerationFailedLogsPage';
import RevenueCatRecoveryPage from './pages/RevenueCatRecoveryPage';
import ApiTokensPage from './pages/ApiTokensPage';
import StoragePage from './pages/StoragePage';
import LocalizationPage from './pages/LocalizationPage';
import AccountDeletionsPage from './pages/AccountDeletionsPage';
import FinancialAnalyticsPage from './pages/FinancialAnalyticsPage';
import UserBehaviorPage from './pages/UserBehaviorPage';
import GenerationQualityPage from './pages/GenerationQualityPage';
import ProtectedRoute from './components/ProtectedRoute';
import RootRedirect from './components/RootRedirect';

/**
 * A data router (rather than <BrowserRouter>) because that is what enables
 * `useBlocker` — pages with an unsaved draft (e.g. Home Layout) use it to
 * intercept sidebar links and the browser Back button. The route tree itself is
 * unchanged; createRoutesFromElements keeps the same JSX.
 */
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/error" element={<ErrorPage />} />

      {/* Protected app routes. Pathless layout route keeps the dashboard
          chrome (sidebar + header) while every page lives at a top-level
          path. */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<PeriodDashboardPage />} />
        <Route path="/dashboard/legacy" element={<LegacyOverviewPage />} />
        <Route path="/analytics/behavior" element={<UserBehaviorPage />} />
        <Route path="/analytics/financial" element={<FinancialAnalyticsPage />} />
        <Route path="/analytics/generation-quality" element={<GenerationQualityPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:userId" element={<UsersPage />} />
        <Route path="/extensions" element={<ExtensionsPage />} />
        <Route path="/extensions/:extensionId" element={<ExtensionsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/promocodes" element={<PromocodesPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/home-layout" element={<HomeLayoutPage />} />
        <Route path="/boosted-creators" element={<BoostedCreatorsPage />} />
        <Route path="/boost" element={<BoostPage />} />
        <Route path="/payouts" element={<PayoutRequestsPage />} />
        <Route path="/versions" element={<VersionControlPage />} />
        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route path="/models" element={<ModelsPage />} />
        <Route path="/generation-usage" element={<GenerationUsagePage />} />
        <Route path="/analytics/credits" element={<CreditUsagePage />} />
        <Route path="/generation-failed-logs" element={<GenerationFailedLogsPage />} />
        <Route path="/revenuecat-recovery" element={<RevenueCatRecoveryPage />} />
        <Route path="/api-tokens" element={<ApiTokensPage />} />
        <Route path="/storage" element={<StoragePage />} />
        <Route path="/localization" element={<LocalizationPage />} />
        <Route path="/account-deletions" element={<AccountDeletionsPage />} />
      </Route>

      {/* Default route - redirect based on auth status */}
      <Route path="/" element={<RootRedirect />} />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
